export const BUCKET_IDS = {
  RECENT_ACTIONS: "recent-actions",
  NAVIGATION: "navigation",
  INTEGRATIONS: "integrations",
  ORGANIZATION_SETTINGS: "organization-settings",
  CREATE: "create",
  SETTINGS: "settings",
  SEARCH: "search",
  ASK_INFRA_ASSISTANT: "ask-infra-assistant",
} as const;

export const SUB_LIST_VIEWS = {
  STACKS_SEARCH: "stacks-search",
  MODULES_SEARCH: "modules-search",
  POLICIES_SEARCH: "policies-search",
  CONTEXTS_SEARCH: "contexts-search",
} as const;

export type SubListViewKey = (typeof SUB_LIST_VIEWS)[keyof typeof SUB_LIST_VIEWS];
